export enum CreditasAffiliates {
  State = 'creditas-affiliates-state',
  Token = 'creditas-affiliates-token',
  RefreshToken = 'creditas-affiliates-refresh-token',
  ExpiresIn = 'creditas-affiliates-expires',
}
